export const actions = {
  REQUEST_TOKEN: "casino/REQUEST_TOKEN",
  RECEIVE_TOKEN: "casino/RECEIVE_TOKEN",
  RECEIVE_TRANSACTIONS: "casino/RECEIVE_TRANSACTIONS",
  REQUEST_PRODUCTS: "casino/REQUEST_PRODUCTS",
  RECEIVE_PRODUCTS: "casino/RECEIVE_PRODUCTS",
  REQUEST_APPLY_POSTPAID: "casino/REQUEST_APPLY_POSTPAID",
  RECEIVE_APPLY_POSTPAID: "casino/RECEIVE_APPLY_POSTPAID",
  SET_PAY_DETAILS: "casino/SET_PAY_DETAILS",
  SET_CATEGORY: "casino/SET_CATEGORY",
  SET_PRODUCT: "casino/SET_PRODUCT",
  SET_LOADING: "casino/SET_LOADING",
};

const initialState = {
  products: [],
  payDetails: {},
  sessionDetails: {},
  transactions: [],
  category: {},
  product: {},
  loading: true,
};

export default function casinoPlusReducers(state = initialState, action) {
  switch (action.type) {
    case actions.RECEIVE_TOKEN:
      return { ...state, sessionDetails: action.payload };
    case actions.RECEIVE_PRODUCTS:
      return { ...state, products: action.payload };
    case actions.RECEIVE_TRANSACTIONS:
      return { ...state, transactions: action.payload };
    case actions.RECEIVE_APPLY_POSTPAID:
    case actions.SET_PAY_DETAILS:
      return { ...state, payDetails: action.payload };
    case actions.SET_CATEGORY:
      return { ...state, category: action.payload };
    case actions.SET_PRODUCT:
      return { ...state, product: action.payload };
    case actions.SET_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}
